/*****
 * MULTILIST ENTRY
 *
 * A multilist is a list of lists, and this is one of those constituent lists.
 * Again, it's used exclusively for visit notes as 12/15.
 *
 * All the events are bound at the multilist level. This object
 * can only be created within a multilist
 *****/

goog.provide('el8.uiwidget.multilistEntry');

goog.require('el8.util.dom');
goog.require('el8.util.consts');
goog.require('el8.uiwidget.listeditor');
goog.require('el8.service.infoField');
goog.require('el8.template.uiwidget.multilist');


el8.uiwidget.multilistEntry = function(opts) {

    this.getItemIdFn = opts.getItemIdFn || null;
    this.getItemTextFn = opts.getItemTextFn || null;
    this.getChildItemTriggerFn = opts.getChildItemTriggerFn || null;

    this.entryHeight = opts.entryHeight || el8.util.consts.DEFAULT_FIELD_HEIGHT;
    this.entryWidth = opts.entryWidth || null;
    this.index = opts.index;
    this.isNumbered = opts.isNumbered;
    this.isSortable = opts.isSortable;

    this.parentSaveFn = opts.parentSaveFn || function() {};
    this.parentRemoveFn = opts.parentRemoveFn || function() {};
    this.destroyFn = opts.destroyFn;

    this.mindreaderOpts = opts.mindreaderOpts || null;
    this.listeditorOpts = opts.listeditorOpts || null;

    this.childTriggerMap = opts.childTriggerMap;

    this.childSaveFn = opts.childSaveFn || null;
    this.genChildSaveFn = opts.genChildSaveFn || null;

    this.childRemoveFn = opts.childRemoveFn || null;
    this.genChildRemoveFn = opts.genChildRemoveFn || null;

    // Can be used to render an uneditable text section
    // beneath each ML entry that represents coded data
    // attached to the entry (e.g., DX codes on an assessment bullet)
    this.getItemAnnotationFn = opts.getItemAnnotationFn || null;

    /* Needs to know about nextElt to link up
     * sublist (listeditor) appropriately
     */
    this.nextElt = opts.nextElt || null;
    /**
     * This contains the entire DOM elt that constitutes this entry
     */
    this.$entryContainer = null;
    /**
     * This is the input entry at the top level
     */
    this.$parentInput = null;
    /**
     * This is the infoField for parent input entry
     */
    this.infoField = null;
    /**
     * This is the <ul> that holds the sublist
     */
    this.$sublist = null;
    /**
     * This is the listeditor widget
     */
    this.listeditor = null;

    /**
     * State variables
     */
    this._awaitingId = false;
    this._lastSavedEntryMap = {}; // For dirty checking

};

el8.uiwidget.multilistEntry.prototype.init = function($mlList) {
    this.$entryContainer = $(el8.template.uiwidget.multilist.entry({
        index: this.index,
        isNumbered: this.isNumbered,
        isSortable: this.isSortable,
        hasAnnotations: Boolean(this.getItemAnnotationFn)
    }));
    $mlList.append(this.$entryContainer);

    this.$parentInput = $('.ml-parent', this.$entryContainer);
    $('.ml-parentedit', this.$parentInput).css('width', '100%');

    this.infoField = el8.service.infoField.addInfoField({
        field: $('.ml-parentedit', this.$parentInput),
        infoText: 'input item here...',
        wrapper: '.le-entry'
    });
    if (this.entryWidth) {
        $('.ml-container', this.$entryContainer).outerWidth(this.entryWidth);
    }

    return this;
};

el8.uiwidget.multilistEntry.prototype.setAwaitingId = function(val) {
    this._awaitingId = Boolean(val);
};

el8.uiwidget.multilistEntry.prototype.setNextElt = function(elt) {
    this.nextElt = elt;
    if (this.listeditor) {
        this.listeditor.setNextElt(elt);
    }
};

el8.uiwidget.multilistEntry.prototype.getListeditor = function() {
    return this.listeditor;
};

el8.uiwidget.multilistEntry.prototype.setParentId = function(id) {
    var isNewId = (this.getParentId()*1 !== id*1);
    this.$parentInput.attr('_id', id);
    if ((!this.childSaveFn || isNewId) && this.genChildSaveFn) {
        this.childSaveFn = this.genChildSaveFn(id);
    }
    if ((!this.childRemoveFn || isNewId) && this.genChildRemoveFn) {
        this.childRemoveFn = this.genChildRemoveFn(id);
    }

};

el8.uiwidget.multilistEntry.prototype.getParentId = function() {
    var id = this.$parentInput.attr('_id') || null;
    return id ? id * 1 : null;
};

el8.uiwidget.multilistEntry.prototype.getParentInput = function() {
    return this.infoField.getInputField();
};
el8.uiwidget.multilistEntry.prototype.getParentInputVal = function() {
    return this.infoField.getVal();
};

el8.uiwidget.multilistEntry.prototype.setParentInputVal = function(val, opts) {
    // opts: triggerName, doHighlight, doSave, async, annotationHtml
    val = val || '';
    this.infoField.setVal(val);
    this._computeParentInputEditSizes();
    var displayVal = el8.util.string.newlinesToBr(val.el8_escape());
    $('.ml-parentdisplay', this.$parentInput).html(displayVal);
    if (opts.triggerName) {
        this.$parentInput.append(el8.template.uiwidget.multilist.trigger({
            triggerName: opts.triggerName
        }));
    }
    if (opts.annotationHtml) {
        $('.ml-annotation', this.$entryContainer).html(opts.annotationHtml);
    }
    this._displayParentInput((opts.doSave !== false), opts.async); // default is true
    if (opts.doHighlight) {
        var $wrap = $('.le-entry', this.$entryContainer);
        $wrap.addClass('el8BlueHighlight');
        $.el8_setTimeout(function() { $wrap.removeClass('el8BlueHighlight'); }, 10000);
    }

    // When setting the parent val externally, update the entryMap to mark clean. E.g.
    // when .addEntry is called on the parent. This happens when populating VNs
    this._lastSavedEntryMap = this.getEntryAsMap();
};

el8.uiwidget.multilistEntry.prototype.setIndex = function(index) {
    this.$entryContainer.attr('_ml_index', index);
    $('.ml-label-number', this.$entryContainer).text(index+1+':');
};
el8.uiwidget.multilistEntry.prototype.getIndex = function() {
    return this.$entryContainer.attr('_ml_index')*1;
};

el8.uiwidget.multilistEntry.prototype.destroy = function() {
    this.$entryContainer.remove();
    if (this.getParentId()) {
        this.parentRemoveFn(this.getParentId());
    }
    this.destroyFn(this);
};

el8.uiwidget.multilistEntry.prototype.initSublist = function() {
    // Be extra safe! Require a childSaveFn and childRemoveFn in order to create listeditor
    if (!this.listeditor) {
        this.$sublist = $('<ol class="ml-sublist">');
        this.$entryContainer.find('.ml-container').append(this.$sublist);
        var opts = this.listeditorOpts || {};
        $.extend(opts, {
            editFriendly: true,
            autoHideInput: true,
            list: this.$sublist,
            prevElt: $('.ml-parentedit', this.$parentInput),
            nextElt: this.nextElt,
            saveFn: this.childSaveFn,
            getItemTextFn: this.getItemTextFn,
            getItemIdFn: this.getItemIdFn,
            getItemTriggerFn: this.getChildItemTriggerFn,
            shouldItemHighlightFn: this.shouldItemHighlightFn,
            triggerMap: this.childTriggerMap,
            removeFn: this.childRemoveFn,
            mindreaderOpts: this.mindreaderOpts
        });
        this.listeditor = new el8.uiwidget.listeditor(opts).init();
    }
    if ((!this.childSaveFn && this.genChildSaveFn) || (!this.childRemoveFn && this.genChildRemoveFn)) {
        //el8.appservice.status.displayNoInternet(); removed because it was displaying all the item with icd9/cpt use of multilist
        UIM && UIM.logError(
            'multilist parent missing childSaveFn or childRemoveFn: (' + this.getParentId() + ', ' + this.getParentInputVal() +')');
    }
};

el8.uiwidget.multilistEntry.prototype._editParentInput = function() {
    this.$parentInput.closest('.le-entry').addClass('active');
    // var $display = $('.ml-parentdisplay', this.$parentInput);
    // var displayVal = el8.util.string.brToNewlines($display.html());
    // this.infoField.setVal(displayVal);
    // this._computeParentInputEditSizes();
};

el8.uiwidget.multilistEntry.prototype._displayParentInput = function(doSave, async) {
    var val = this.infoField.getVal();
    var displayVal = el8.util.string.newlinesToBr(val.el8_escape());
    $('.ml-parentdisplay', this.$parentInput).html(displayVal);
    this._computeParentInputDisplaySizes();

    this.$parentInput.closest('.le-entry').removeClass('active');

    if (doSave !== false) {
        this._saveParent(async);
    }
};

el8.uiwidget.multilistEntry.prototype._saveParent = function(async) {
    if (async === undefined) {
        // If async isn't explicitly specified,
        // upon first save set async to false (do sync save)
        async = Boolean(this.getParentId());
    }
    var that = this;

    /* If parent is empty and there are no children, then destroy entry */
    if (!this.infoField.getVal() && (!this.listeditor || this.listeditor.isEmpty())) {
        this.destroy();

    /* Else, save parent normally */
    } else {
        this.parentSaveFn(this.getParentId(), this.infoField.getVal(), this.getIndex(), {
            successCb: function(item) {
                if (item) { that.setParentId(item.getId()); }
                that._lastSavedEntryMap = that.getEntryAsMap();

                // Removing highlight from visit note template if we edited it
                // and server marks it as not coming from VNT - but only when
                // the item actually has the isEditedByVnt field

                if (that.listeditor && that.listeditor.shouldItemHighlightFn(item)) {
                    that.infoField.getInputField().closest('.le-entry').addClass('el8BlueHighlight');
                } else {
                    that.infoField.getInputField().closest('.le-entry').removeClass('el8BlueHighlight');
                }
            },
            errorCb: function() {},
            async: async
        });
    }
};

el8.uiwidget.multilistEntry.prototype._computeParentInputEditSizes = function() {
    var dispHeight = $('.ml-parentdisplay', this.$parentInput).height();

    this.$parentInput.parent('.le-entry').height(
        Math.max(this.entryHeight, dispHeight)
    );

    $('.ml-parentedit', this.$parentInput)
        .height(Math.max(this.entryHeight, dispHeight));
};

el8.uiwidget.multilistEntry.prototype._computeParentInputDisplaySizes = function() {
    var dispHeight = $('.ml-parentdisplay', this.$parentInput).height();

    this.$parentInput.parent('.le-entry').height(
        Math.max(this.entryHeight, dispHeight)
    );

    $('.ml-parentedit', this.$parentInput)
        .height(Math.max(this.entryHeight, dispHeight));
};

el8.uiwidget.multilistEntry.prototype.isParentActive = function() {
    return this.$parentInput.closest('.le-entry').hasClass('active');
};

el8.uiwidget.multilistEntry.prototype.hasSublist = function() {
    return !!this.listeditor;
};

el8.uiwidget.multilistEntry.prototype.activateSublist = function() {
    this.initSublist();
    this.listeditor._activateInput();
};

el8.uiwidget.multilistEntry.prototype.activateSublistTop = function() {
    if (this.hasSublist()) {
        if (this.listeditor.isEmpty()) {
            this.listeditor._activateInput();
        } else {
            this.listeditor.setActiveEntry(0);
        }
    }
};

el8.uiwidget.multilistEntry.prototype.activateEntryBottom  = function() {
    if (this.hasSublist()) {
        this.listeditor._activateInput();
    } else {
        this.activateParentInput();
    }
};

el8.uiwidget.multilistEntry.prototype.activateParentInput = function() {
    this._editParentInput();
    this.getParentInput().scrollintoview().focusFocus();
};

el8.uiwidget.multilistEntry.prototype.removeParentTrigger = function() {
    this.$parentInput.find('.ml-trigger').remove();
};

el8.uiwidget.multilistEntry.prototype.getEntryAsMap = function() {
    return {
        'parentObj': {
            'id': this.getParentId(),
            'text': this.infoField.getVal()
        },
        'children': !this.getListeditor() ? [] :
            this.getListeditor().getAllEntries()
    };
};

el8.uiwidget.multilistEntry.prototype.getEntryJsonData = function() {
    var data = {
        'text': this.infoField.getVal()
    };

    if (this.getListeditor()) {
        data['children'] = this.getListeditor().getJsonData();
    }
    return data;
};

el8.uiwidget.multilistEntry.prototype.isDirty = function() {
   var saved = this._lastSavedEntryMap;
   var currentMap = this.getEntryAsMap();

    // Check if inited, save if not
    if (!saved.parentObj || !saved.parentObj.id || !saved.parentObj.text) {
        return true;
    }

   if (currentMap.parentObj.id !== saved.parentObj.id ||
       currentMap.parentObj.text !== saved.parentObj.text) {
        return true;
   }

   return false;
};

el8.uiwidget.multilistEntry.prototype.saveIfDirty = function() {
    // We want this fn to run _after_ any in-flight bullet saves are compeleted. The canonical
    // way to do that is _.defer() queues the fn to the end of the browser's message queue
    // and runs only after any previously queued messages are done and the call stack is clear
    // (i.e. the bullet save callbacks are completed).
    var fn = function () {
        // Check parent
        if (this.isDirty()) { this._saveParent(false); }

        // Check child listeditor independently
        if (this.listeditor) {
            if (!this.listeditor.hasSaveFn() && this.genChildSaveFn) {
                this.listeditor.setSaveFn(this.genChildSaveFn(this.getParentId()));
            }
            this.listeditor.saveIfDirty();
        }
    };

    _.defer(_.bind(fn, this));
};

el8.uiwidget.multilistEntry.prototype.getEntryContainer = function() {
    return this.$entryContainer;
};

